import emitter from "./event-bus";

const spinnerSVG = `
  <div class="loader-overlay">
    <div class="w-12 h-12">
      <svg xmlns="http://www.w3.org/2000/svg"
           viewBox="0 0 40 40"
           fill="none"
           class="w-full h-full spinning">
        <circle cx="20" cy="20" r="17.5" stroke="#FAE6E8" stroke-width="5" />
        <path d="M 20 2.5 A 17.5 17.5 0 0 1 30.286 34.158" stroke="#D21E2E" stroke-width="5" stroke-linecap="round" />
      </svg>
    </div>
  </div>
`;

const getLoaderElement = (): HTMLElement | null => {
    return document.getElementById("loader");
};

const showLoadingOverlay = () => {
    const target = getLoaderElement();
    if (!target) return;

    if (!target.classList.contains("loader-wrapper")) {
        const wrapper = document.createElement("div");
        wrapper.classList.add("loader-wrapper");
        target.parentNode?.insertBefore(wrapper, target);
        wrapper.appendChild(target);
    }

    if (!target.parentElement?.querySelector(".loader-overlay")) {
        target.insertAdjacentHTML("beforebegin", spinnerSVG);
    }
};

const hideLoadingOverlay = () => {
    const target = getLoaderElement();
    if (!target) return;

    const overlay = target.parentElement?.querySelector(".loader-overlay");
    if (!overlay) return;
    overlay.classList.add("hide");
    setTimeout(() => {
        overlay.remove();
    }, 300);
};

showLoadingOverlay();
emitter.on("load-start", showLoadingOverlay);
emitter.on("load-stop", hideLoadingOverlay);
